import React, { useState } from 'react';

const PAGE_SIZE = 20;

export default function MissingFieldsTable({ requiredFields }) {
  const [page, setPage] = useState(0);
  const { rows_with_issues, total_rows, rows_with_issue_count } = requiredFields;
  const totalIssueRows = rows_with_issue_count ?? rows_with_issues.length;

  if (rows_with_issues.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow-sm p-6">
        <h3 className="text-sm font-semibold text-slate-700 mb-2">Assets Missing Required Fields</h3>
        <div className="bg-green-50 border border-green-200 rounded-lg p-4 text-sm text-green-800">
          All {total_rows.toLocaleString()} assets have the mandatory fields populated. Ready for mapping.
        </div>
      </div>
    );
  }

  const totalPages = Math.ceil(rows_with_issues.length / PAGE_SIZE);
  const pageItems = rows_with_issues.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE);

  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <div className="flex justify-between items-baseline mb-4">
        <h3 className="text-sm font-semibold text-slate-700">Assets Missing Required Fields</h3>
        <span className="text-xs text-slate-500">
          {totalIssueRows.toLocaleString()} of {total_rows.toLocaleString()} assets have gaps
        </span>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-slate-200">
              <th className="text-left py-2 px-3 text-xs font-semibold text-slate-500 uppercase">Row</th>
              <th className="text-left py-2 px-3 text-xs font-semibold text-slate-500 uppercase">Asset</th>
              <th className="text-left py-2 px-3 text-xs font-semibold text-slate-500 uppercase">Missing Fields</th>
            </tr>
          </thead>
          <tbody>
            {pageItems.map((item) => (
              <tr key={item.row_index} className="border-b border-slate-100 hover:bg-slate-50">
                <td className="py-2 px-3 text-slate-500">{item.row_index + 1}</td>
                <td className="py-2 px-3 text-slate-800 font-medium truncate max-w-xs">{item.filename}</td>
                <td className="py-2 px-3">
                  <div className="flex gap-1.5 flex-wrap">
                    {item.missing_fields.map(field => (
                      <span key={field} className="bg-red-100 text-red-700 px-2 py-0.5 rounded text-xs font-medium">
                        {field}
                      </span>
                    ))}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {totalPages > 1 && (
        <div className="flex items-center justify-between mt-4 pt-3 border-t border-slate-100">
          <button
            onClick={() => setPage(p => Math.max(0, p - 1))}
            disabled={page === 0}
            className="text-sm text-slate-600 hover:text-slate-800 disabled:text-slate-300 disabled:cursor-not-allowed"
          >
            Previous
          </button>
          <span className="text-xs text-slate-500">
            Page {page + 1} of {totalPages}
          </span>
          <button
            onClick={() => setPage(p => Math.min(totalPages - 1, p + 1))}
            disabled={page >= totalPages - 1}
            className="text-sm text-slate-600 hover:text-slate-800 disabled:text-slate-300 disabled:cursor-not-allowed"
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
}
